export const FirebaseConfig = {
	"projectId": "wasaaly-f640b",
	"appId": "1:590626844864:web:a9d0508293a1e35bfa7d25",
	"databaseURL": "https://wasaaly-f640b-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "wasaaly-f640b.appspot.com",
	"locationId": "europe-west",
	"apiKey": "AIzaSyBz97xoCTJbluiDxfMADSz2Owx3VNBGV6I",
	"authDomain": "wasaaly-f640b.firebaseapp.com",
	"messagingSenderId": "590626844864",
	"measurementId": "G-4LRR6P6KFN"
};